import Choices from "choices.js"

let formsSelects = document.querySelectorAll('.select--choices');
let filterSelects = document.querySelectorAll('.filter--choices');

const initChoices = () => {

    const applyChoicesCustom = (selectsToCustom, classes) => {

        if (selectsToCustom) {

            selectsToCustom.forEach(select => {
                const choices = new Choices(select, {
                    searchEnabled: false,
                    duplicateItemsAllowed: false,
                    classNames: {
                        containerOuter: classes,
                    }
                });
            })
        }
    }
    applyChoicesCustom(formsSelects, 'choices');
    applyChoicesCustom(filterSelects, 'choices choices--filter');
}

    initChoices();


jQuery(document).on('nfFormReady', function () {
    formsSelects = document.querySelectorAll('.select--choices');
    initChoices();
});